import 'babel-polyfill'
import es6Promise from 'es6-promise'
if (!window.Promise) { es6Promise.polyfill() }

import './utils/handleIeCss.js'
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/rem.js'
import './styles/reset.less'
import 'element-ui/lib/theme-chalk/index.css';

// 全局引入
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);

import { Form, FormItem, Input, Select, Option, Button, RadioGroup, Radio, CheckboxGroup, Checkbox, CheckboxButton, MessageBox, Message, Cascader, Dialog, Row, Col } from 'element-ui'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Input)
Vue.use(Cascader)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Col)

Vue.component(Message.name, Message);
Vue.prototype.$message = Message;
Vue.component(MessageBox.name, MessageBox);
Vue.prototype.$messageBox = MessageBox;


Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js